const AUTH_COOKIE_KEY = 'CBS_COM';
const REGISTRATION_REGION_COOKIE_KEY = 'CBS_RR';
const USER_STATUS_COOKIE_KEY = 'CBS_ST';
const CLIENT_REGION_HEADER = 'x-client-region';
const REGION_IN_PATH = 'region-in-path';
// Shared here so browser code can import these names without bundling the server-only
// persisted-document manifest.
const TN_GRAPHQL_ERROR_CODE_HEADER = 'x-tn-graphql-error-code';
const TN_GRAPHQL_SERVER_BUILD_HEADER = 'x-tn-build';
const KID_SESSION_COOKIE_KEY = 'kid_session';
const PIN_SWITCH_COOKIE_KEY = 'pin_switch';
const LAST_KID_PROFILE_COOKIE_KEY = 'last_kid_profile';
const FORWARD_SLASH = '/';
const SEMI_COLON = ';';
const HOME = `${FORWARD_SLASH}home${FORWARD_SLASH}`;
const DEFAULT_MAX_AGE = 31536000;
const ZERO = '0';
const ONE = '1';
const KIDS = 'Kids';

const DEV_LOCATION_COOKIE_KEY = 'CBS_LO';
const DEV_LOCALE_COOKIE_KEY = 'PP_LOCALE';
// Saved consent preferences written by the CMP vendor (currently Ketch). Base64-encoded
// JSON keyed by purpose, each with a "granted"/"denied" status.
const CONSENT_COOKIE_KEY = '_ketch_consent_v1_';
const LOGIN_SESSION_COOKIE = 'UP_NEW_SESSION';
const CMS_OVERRIDES_COOKIE = 'CMS';
// Carries the page's `?cms=` value from SSR prefetches to GraphQL, which never see the page URL.
const CMS_OVERRIDES_HEADER = 'x-tn-cms-overrides';
// Carries the browser's platform session JWT to GraphQL; only sent by callers whose upstream needs it.
const SESSION_JWT_HEADER = 'x-session-jwt';
const ABTEST_API_OVERRIDE_COOKIE_KEY = 'abtest_api_overrides';

const DEVICE_ID_COOKIE = 'ptv_device_id';
const SESSION_ID_COOKIE = 'ptv_session_id';
const SESSION_REFRESH_IN_SEC_COOKIE = 'ptv_jwt_refresh';
const SESSION_JWT_COOKIE = 'ptv_session_jwt';
const LEGACY_CLIENT_ID_COOKIE = 'ptv-client-id';

// Client capability cookies, written client-side and read by the start/restart flows.
const DRM_CAPABILITIES_COOKIE = 'ptv_drm_capabilities';
const CLIENT_DNT_COOKIE = 'ptv_client_dnt';
const US_PRIVACY_COOKIE = 'usprivacy';

const COOKIE_LOADED_VARIANTS = 'lv';
const USER_UUID_COOKIE_NAME = 'ovvuid';
// Backs the variant gateway's channelOriginId param; must not be blocked by the CMP (Ketch).
const LAST_WATCHED_CHANNEL_COOKIE = 'last_watched_channel';
// Trailing slash avoids a 308 redirect (both shells set trailingSlash: true).
const LAST_WATCHED_CHANNEL_API_PATH = '/api/tn/app-shell/last-watched-channel/';
// Backs the variant gateway's appLaunchCount param; must not be blocked by the CMP (Ketch).
const APP_LAUNCH_COUNT_COOKIE = 'app_launch_count';
// ISO-8601 start of the current launch; becomes the next launch's lastAppLaunchDate.
const APP_LAUNCH_DATE_COOKIE = 'app_launch_date';
// Backs the variant gateway's lastAppLaunchDate param; must not be blocked by the CMP (Ketch).
const APP_LAST_LAUNCH_DATE_COOKIE = 'app_last_launch_date';
// Session cookie (no expiry) marking the current launch as recorded. Launches the client does not
// report as new count at most once per browser session, never per tab or reload.
const APP_LAUNCH_SESSION_COOKIE = 'app_launch_session';
// Trailing slash avoids a 308 redirect (both shells set trailingSlash: true).
const APP_LAUNCH_API_PATH = '/api/tn/app-shell/app-launch/';
// Web Lock every open app tab holds, so a tab can tell whether any other app tab is open.
const APP_OPEN_LOCK = 'tn-app-open';
// Exclusive Web Lock serializing tabs' check-and-claim of APP_OPEN_LOCK.
const APP_LAUNCH_CHECK_LOCK = 'tn-app-launch-check';
// sessionStorage marker of a tab whose launch was already reported, so reloads are not new launches.
const APP_LAUNCHED_TAB_KEY = 'tn_app_launched';
const FLOW_ID_SESSION_KEY = 'flowId';
// Post-sign-in redirect destination backed up by the ptvSisu flow. Cleared by the
// Sign In CTA when starting a Front Door flow so a stale value from an abandoned
// SISU attempt can't override the /home fallback. Shared with tn-flows (writer).
const SISU_REDIRECT_URL_SESSION_KEY = 'tn:sisuRedirectUrl';

const MINUTE = 60;
const DEFAULT_CACHE_TTL = MINUTE * 5;
const HEADER_CACHE_CONTROL = 'cache-control';
const HEADER_CACHE_CONTROL_VALUE_PUBLIC = 'public';
const HEADER_CACHE_CONTROL_VALUE_MAX_AGE = 'max-age';
const HEADER_CACHE_CONTROL_VALUE_S_MAX_AGE = 's-maxage';
const HEADER_EXPIRES = 'expires';
const HEADER_SET_COOKIE = 'set-cookie';

const enum CACHE_SCOPE {
    PUBLIC = 'PUBLIC',
    PRIVATE = 'PRIVATE',
}

// Reduced to 4KB to account for cookies and other headers that count toward nginx's
// large_client_header_buffers limit
const MAX_GET_URL_LENGTH = 4 * 1024;

const LOGOS = {
    TWITTER: 'Twitter',
    X: 'X',
    SEARCH: 'Search',
};

const EMPTY_STR = '';
const STRING = 'string';
const UNDEFINED = 'undefined';
const PIPE = '|';
const SPACE = '\u00a0';

const SITE_CODE = 'cbscom';
const SITE_ID = process.env.NEXT_PUBLIC_BUILD_NUMBER;
const DEV = 'dev';
const SITE_PRIMARY_RSID = 'cnetcbscomsite';
const SITE_TYPE = 'response web';
const BRAND_PLATFORM = '_site_';
const PPLUS = 'pplus';
const INTL = 'intl';
const NA = 'na';
const OTHER = 'other';
const PASSWORD = 'password';
const MOBILE = 'mobile';
const DESKTOP = 'desktop';
const MOBILE_WEB = 'mweb';
const BRAND_PLATFORM_WINDOWS_11 = '_pwa_windows11';
const US = 'us';
const HANDLE_ERROR = '[microfrontend]handleError';
const PRODUCTION = 'production';
const PROD = 'prod';
const FAQ_URL = 'https://www.paramountplus.com/FAQ/';
const API_GEOLOCATION_URL = '/api/tn/geolocation/location';
const BLANK = '_blank';
const SELF = '_self';

/** Query key `fac`: from account confirm — logged-in PTV users may open /activate/device with this param after continuing from /account/confirm (middleware bypass). */
const ACTIVATE_DEVICE_FROM_ACCOUNT_CONFIRM_QUERY = 'fac';
const ACTIVATE_DEVICE_FROM_ACCOUNT_CONFIRM_VALUE = '1';

/**
 * Returns the loaded variants cookie name for a given userId.
 * @param userId string
 */
export function getLoadedVariantsCookieName(userId: string): string {
    return `${COOKIE_LOADED_VARIANTS}_${userId}`;
}

// The brand's shell: a relative path on the client, the LOB's shell via getDomain on the server.
// Code that also runs inside the hubs and video bundles names it instead of the bundle's own app.
const SHELL_APP_NAME = 'app-shell' as const;

export {
    ABTEST_API_OVERRIDE_COOKIE_KEY,
    ACTIVATE_DEVICE_FROM_ACCOUNT_CONFIRM_QUERY,
    ACTIVATE_DEVICE_FROM_ACCOUNT_CONFIRM_VALUE,
    API_GEOLOCATION_URL,
    APP_LAST_LAUNCH_DATE_COOKIE,
    APP_LAUNCH_API_PATH,
    APP_LAUNCH_CHECK_LOCK,
    APP_LAUNCH_COUNT_COOKIE,
    APP_LAUNCH_DATE_COOKIE,
    APP_LAUNCH_SESSION_COOKIE,
    APP_LAUNCHED_TAB_KEY,
    APP_OPEN_LOCK,
    AUTH_COOKIE_KEY,
    BLANK,
    BRAND_PLATFORM,
    BRAND_PLATFORM_WINDOWS_11,
    CACHE_SCOPE,
    CLIENT_DNT_COOKIE,
    CLIENT_REGION_HEADER,
    CMS_OVERRIDES_COOKIE,
    CMS_OVERRIDES_HEADER,
    CONSENT_COOKIE_KEY,
    DEFAULT_CACHE_TTL,
    DEFAULT_MAX_AGE,
    DESKTOP,
    DEV,
    DEV_LOCALE_COOKIE_KEY,
    DEV_LOCATION_COOKIE_KEY,
    DEVICE_ID_COOKIE,
    DRM_CAPABILITIES_COOKIE,
    EMPTY_STR,
    FAQ_URL,
    FLOW_ID_SESSION_KEY,
    FORWARD_SLASH,
    HANDLE_ERROR,
    HEADER_CACHE_CONTROL,
    HEADER_CACHE_CONTROL_VALUE_MAX_AGE,
    HEADER_CACHE_CONTROL_VALUE_PUBLIC,
    HEADER_CACHE_CONTROL_VALUE_S_MAX_AGE,
    HEADER_EXPIRES,
    HEADER_SET_COOKIE,
    HOME,
    INTL,
    KID_SESSION_COOKIE_KEY,
    KIDS,
    LAST_KID_PROFILE_COOKIE_KEY,
    LAST_WATCHED_CHANNEL_API_PATH,
    LAST_WATCHED_CHANNEL_COOKIE,
    LEGACY_CLIENT_ID_COOKIE,
    LOGIN_SESSION_COOKIE,
    LOGOS,
    MAX_GET_URL_LENGTH,
    MOBILE,
    MOBILE_WEB,
    NA,
    ONE,
    OTHER,
    PASSWORD,
    PIN_SWITCH_COOKIE_KEY,
    PIPE,
    PPLUS,
    PROD,
    PRODUCTION,
    REGION_IN_PATH,
    REGISTRATION_REGION_COOKIE_KEY,
    SELF,
    SEMI_COLON,
    SESSION_ID_COOKIE,
    SESSION_JWT_COOKIE,
    SESSION_JWT_HEADER,
    SESSION_REFRESH_IN_SEC_COOKIE,
    SHELL_APP_NAME,
    SISU_REDIRECT_URL_SESSION_KEY,
    SITE_CODE,
    SITE_ID,
    SITE_PRIMARY_RSID,
    SITE_TYPE,
    SPACE,
    STRING,
    TN_GRAPHQL_ERROR_CODE_HEADER,
    TN_GRAPHQL_SERVER_BUILD_HEADER,
    UNDEFINED,
    US,
    US_PRIVACY_COOKIE,
    USER_STATUS_COOKIE_KEY,
    USER_UUID_COOKIE_NAME,
    ZERO,
};
